import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/eligible-customer-list",
    name: "Eligible Customer List",
    component: () => import("./eligibleCustomerList.vue"),
  },
] satisfies RouteRecordRaw[];
